// For Firebase JS SDK v7.20.0 and later, measurementId is optional
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyAP1d-2uJpB-lINAc4Mj825cbzU6CLKOZU",
    authDomain: "clone-da593.firebaseapp.com",
    projectId: "clone-da593",
    storageBucket: "clone-da593.appspot.com",
    messagingSenderId: "1092625979241",
    appId: "1:1092625979241:web:7f1e07a54dd65710a50ff8",
    measurementId: "G-9B18N79MN6"
  };

  const firebaseApp = firebase.initializeApp(firebaseConfig);

  const db = firebaseApp.firestore();
  const auth = firebase.auth();
  
  export { db, auth };